import { atom } from 'jotai';

export const powerBi = atom({ bearerToken: '', id: '', embedUrl: '', accessToken: '', reports: [] as any[] });
